import { querySelectorURL } from "../../cpcoc/querySelectorURL";
import { executeSearch } from "./executeSearch";
export function initSearch() {
    const searchInput = document.querySelector("#group-search");
    const query = querySelectorURL("q");
    const queryVal = typeof query === "string" ? query : "";
    let waitForIt;
    searchInput.value = queryVal;
    searchInput.removeAttribute("disabled");
    searchInput.focus();
    executeSearch(queryVal); // execute on load
    searchInput.addEventListener("keyup", (e) => {
        const val = e.target.value;
        clearTimeout(waitForIt);
        waitForIt = window.setTimeout(() => {
            // debounce
            executeSearch(val);
            // update the url
            const url = new URL(window.location.toString());
            if (val) {
                url.searchParams.set("q", val);
            }
            else {
                url.searchParams.delete("q");
            }
            window.history.pushState({}, "", url);
        }, 300);
    });
}
